/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getSettingActions, {
    getSettingTypes,
} from '../../../redux/settings/getSetting'
import { Get } from '../../../serveur/axios'

function* getSettingSagas() {
    try {
        const res = yield Get('delais/')

        if (res.status === 200) {
            yield all([
                yield put(getSettingActions.getSettingSuccess(res.data.data)),
            ])
        } else {
            yield put(getSettingActions.getSettingFailure(res.data.data))
        }
    } catch (error) {
        yield put(getSettingActions.getSettingFailure(error))
    }
}

export function* getSettingSaga() {
    yield takeLatest(getSettingTypes.GET_SETTING_REQUEST, getSettingSagas)
}
